import { computed } from 'vue';
import { useStore } from 'vuex';

export function usePremiumFeature({
  feature = null,
  limit = null,
  variant = null,
}) {
  const store = useStore();
  const features = computed(() => store.getters['features/getFeatures']);

  if (!feature) {
    throw new Error('usePremiumFeature requires feature props');
  }

  if (
    !features.value[feature] ||
    features.value[feature].is_supported === undefined
  ) {
    throw new Error(
      `usePremiumFeature requires is_supported property in features, ${feature} feature is missing or is_supported is not defined.`
    );
  }

  const isSupported = computed(() => {
    let result = features.value[feature].is_supported;
    if (limit) {
      result =
        result &&
        (features.value[feature].limit !== -1
          ? features.value[feature].limit > limit
          : true);
    }
    if (variant && Array.isArray(features.value[feature].variants)) {
      result = result && features.value[feature].variants.includes(variant);
    }
    return result;
  });

  const isLimited = computed(() => {
    if (typeof features.value[feature].limit === 'number') {
      if (features.value[feature].limit === -1) {
        return false;
      }
      return true;
    }
    return false;
  });

  const featureLimit = computed(() => features.value[feature].limit);

  const supportedVariants = computed(() => features.value[feature].variants);

  return {
    isSupported,
    limit: featureLimit,
    isLimited,
    supportedVariants,
  };
}
